import Entity from '../entity'
export default class ParticipacionDato extends Entity<number>{
    campoId: number;
    participacionId: number;
    numerico: number;
    texto: string;
    decimal: number;
    siNo: boolean;
    fecha: string;
    url: string;
    
}